import bg2 from "../../images/slider/LUD_3386.jpg";
import bg1 from "../../images/slider/©Antoine_Meyssonnier-4631.jpg";
import bg3 from "../../images/slider/©Antoine_Meyssonnier-4653.jpg";

import { Slider } from "@/src/data/types";
import Autoplay from "embla-carousel-autoplay";
import { useEffect, useState } from "react";
import { CiSearch } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { getAllSliders } from "../../API/Slider/sliderService";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "../../components/ui/carousel";
import user from "../../images/icons/user.png";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

const bgImages = [
  { id: "1", image: bg1 },
  { id: "2", image: bg2 },
  { id: "3", image: bg3 },
];

const HomeSection = () => {
  const [sliders, setSliders] = useState<Slider[]>([]);
  const fetchData = async () => {
    const response = await getAllSliders();
    setSliders(response?.sliders);
  };
  useEffect(() => {
    fetchData();
  }, []);

  const search = [
    {
      id: 1,
      name: "Recrutement",
      link: "/recrutement",
    },
    {
      id: 2,
      name: "Médiathèque",
      link: "/mediatheque",
    },
    {
      id: 3,
      name: "Presse",
      link: "/presse",
    },
    {
      id: 4,
      name: "Actualités",
      link: "/actualités",
    },
  ];

  const [keyword, setKeyword] = useState(""); // To hold the input value
  const navigate = useNavigate(); // To navigate programmatically

  // Handle input change
  const handleInputChange = (e: any) => {
    setKeyword(e.target.value); // Update state with input value
  };
  const handleSearchClick = () => {
    if (keyword) {
      // Navigate to /recherche with the keyword as a query parameter
      navigate(`/recherche?keyword=${encodeURIComponent(keyword)}`);
    }
  };

  return (
    <>
      <div className="relative p-24 ">
        <div className="absolute inset-0">
          <Carousel
            opts={{ loop: true }}
            plugins={[
              Autoplay({
                delay: 2000,
              }),
            ]}
          >
            <CarouselContent>
              {bgImages.map((slider) => (
                <CarouselItem key={slider.id}>
                  <img
                    src={slider.image}
                    alt={`Carousel Image ${slider.id}`}
                    style={{ height: "700px", width: "100%" }}
                  />
                </CarouselItem>
              ))}
            </CarouselContent>
            <div></div>
          </Carousel>
        </div>

        <div className="relative mt-20">
          <div className="items-center text-5xl font-bold text-center text-white md:text-7xl">
            Aquavesc
          </div>
          <div className="text-2xl font-bold text-center text-white mt-14 md:text-5xl">
            L'innovation au service de l'eau
          </div>
        </div>

        <div className="hidden text-center md:mt-12 md:block">
          <div className="relative mx-auto w-[600px]">
            {/* Wrapper for the input, icon, and button */}
            <div className="relative flex items-center">
              {/* Search Icon */}
              <div className="absolute pointer-events-none left-3">
                <CiSearch className="w-5 h-5 text-black" />
              </div>

              {/* Search Input */}
              <Input
                className="py-3 pl-12 pr-12 text-black bg-white border border-gray-300 h-9 rounded-3xl focus:outline-none focus:border-primary"
                placeholder="Que cherchez vous..."
                // value={keyword}
                // onChange={handleInputChange}
              />

              {/* Search Button */}
              <Button
                className="absolute top-0 bottom-0 right-0 px-6 py-3 text-white rounded-r-md bg-primary rounded-3xl"
                //onClick={handleSearchClick}
              >
                Recherche
              </Button>
            </div>
            {/* <div className="grid grid-cols-5 mt-2">
              {search.map((item) => (
                <div key={item.id}>
                  <Link to={item.link}>
                    <Badge>{item.name}</Badge>
                  </Link>
                </div>
              ))}
            </div> */}
          </div>

          <div className="absolute right-0 bottom-4">
            <a
              href="https://portail.eauxseineouest.fr/DocuWareProxy/sso?returnUrl=/home"
              target="_blank"
              rel="noreferrer"
            >
              <Button className="w-24 rounded-none h-14">
                <div className="flex items-center justify-center space-x-2">
                  <div>
                    <img src={user} alt="" className="text-white " />
                  </div>
                  <div>ELU</div>
                </div>
              </Button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeSection;
